import React, { useState } from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import OperationReportLayout from './components/operation_report_layout';
import { useLocation } from 'react-router-dom';

const OperationReport = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [filter, setFilter] = useState({
        page : queryParams.get("page"),
        entrance : queryParams.get("entrance")?.split(',')?.map(Number)?.filter(x => x != 0),
        search : queryParams.get("search"),
        start_date : queryParams.get("start_date"),
        end_date : queryParams.get("end_date"),
        transaction_type : queryParams.get("transaction_type"),
        inout : queryParams?.get("inout")?.split(',')?.map(Boolean)?.filter(x => x != null),
    })
    return (
        <>
            <ContainerComponent span={22} top={20} bottom={20}>
                <OperationReportLayout default_filter={filter} />
            </ContainerComponent>
        </>
    );
}

export default OperationReport;